import { FC } from 'react';

import { SignInForm } from './SignInForm';
import {
    Card,
    CardDescription,
    CardHeader,
    CardTitle,
} from '../../components/ui/Card';

const SignIn: FC = () => (
    <div className="flex w-full items-center justify-center lg:w-1/2 lg:p-8 xl:w-1/3">
        <div className="mx-auto w-full max-w-sm space-y-6">
            <Card className="w-full rounded-2xl border-0 shadow-none sm:border sm:shadow-lg">
                <CardHeader className="space-y-1 pb-4 text-center sm:pb-6">
                    <CardTitle className="text-2xl font-bold sm:text-3xl">
                        Увійти
                    </CardTitle>
                    <CardDescription className="text-sm text-muted-foreground">
                        Введіть дані для доступу до вашого облікового запису
                    </CardDescription>
                </CardHeader>

                <SignInForm />
            </Card>
        </div>
    </div>
);

export default SignIn;
